import AdminDocumentValidationAcceptModal from "./AcceptModal";
export default AdminDocumentValidationAcceptModal;
